import { DataTableImageColumn } from "~components/DataTable/components/DataTableImageColumn/DataTableImageColumn.tsx";
import { ImageTypes } from "~enums/imageTypes";
import type { Person } from "~types/person";

type Props = {
  person: Person;
};
const PersonColumn = ({ person }: Props) => {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
      {person && <DataTableImageColumn images={person?.images} imageTypes={[ImageTypes.PersonHead]} />}
      <span>{person?.nameFullLocal}</span>
    </div>
  );
};
export default PersonColumn;
